<template>
  <div>
    <list
      ref="list"
      unit="访客"
      row-key="Id"
      :page="page"
      :query-params="params"
      :show-checkbox="showCheckbox"
      :show-query="showQuery"
      :get-data-func="api.list"
      @row-select="x=>$emit('change', x)"
      @reset-query="$emit('reset-select')"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="单据编号">
          <el-input size="mini" clearable v-model="params.DocNo" placeholder="请输入单据编号" />
        </el-form-item>
        <el-form-item label="单据日期">
          <el-date-picker
            size="mini"
            v-model.trim="params.DocDateStart"
            placeholder="请选择日期"
            value-format="yyyy-MM-dd"
            style="width: 180px"
          ></el-date-picker>
          <span style="margin:0 10px;">-</span>
          <el-date-picker
            size="mini"
            v-model.trim="params.DocDateEnd"
            placeholder="请选择日期"
            value-format="yyyy-MM-dd"
            style="width: 180px"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="盘点仓库">
          <el-select
            size="mini"
            v-model="params.WarehouseId"
            placeholder="请选择"
          >
          <el-option v-for="item in wareList" :key="item.WarehouseId" :label="item.WarehouseName" :value="item.WarehouseId"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="商品名称">
          <el-input size="mini" clearable v-model="params.GoodsName" placeholder="请输入商品名称" />
        </el-form-item> -->
        <el-form-item label="盘点人员">
          <el-input size="mini" clearable v-model="params.EmpName" placeholder="请输入盘点人员" />
        </el-form-item>
        <el-form-item label="单据状态">
          <el-select size="mini" v-model="params.Status" placeholder="请选择" clearable>
            <el-option label="草稿" :value="0"></el-option>
            <el-option label="未生效" :value="1"></el-option>
            <el-option label="已生效" :value="2"></el-option>
          </el-select>
        </el-form-item>
      </template>
      <template slot="tab">
        <el-tabs v-model="activeName" type="card" @tab-click="activeFun">
          <el-tab-pane label="盘点单" name="0"></el-tab-pane>
          <el-tab-pane label="分量盘点单" name="1"></el-tab-pane>
        </el-tabs>
      </template>
      <template slot="table">
        <el-table-column prop="DocNo" label="单据编号"/>
        <el-table-column prop="DocDate" label="单据日期" min-width="110px">
          <template slot-scope="{row}">
            {{row.DocDate.split(" ")[0]}}
          </template>
        </el-table-column>
        <el-table-column prop="WarehouseName" label="盘点仓库"/>
        <el-table-column prop="EmpName" label="盘点人员" v-if="activeName==1" />
        <el-table-column prop="Status" label="单据状态">
          <template slot-scope="{row}">
            <span v-if="row.Status==0">草稿</span>
            <span v-else-if="row.Status==1">未生效</span>
            <span v-else>已生效</span>
          </template>
        </el-table-column>
        <el-table-column prop="Remark" label="备注" min-width="100px"/>
        <slot name="column"></slot>
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";

export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      api: require("@/api/stock/inventory").default,
      wareApi: require("@/api/ba/warehouse").default,
      activeName: 0,
      wareList: [],
      params: {
        DocType:0,
        DocNo: "",
        DocDateStart: "",
        DocDateEnd: "",
        EmpName: "",
        WholeHouseName: "",
        DocDateStart:this.$commonJs.getDayOffset(-30),
        DocDateEnd:this.$commonJs.getDayOffset(0)
      }
    };
  },
  beforeMount() {
    // this.$refs.list.query({ LevelType: 0 })
  },
  mounted() {
    this.wareApi.list({ PageIndex: 1, PageSize: 100 }).then(res => {
      this.wareList = res.Data
      sessionStorage.setItem("ware",JSON.stringify(res.Data))
    })
  },
  methods: {
    activeFun(){
      this.params.DocType=this.activeName
      this.$refs.list.getData(this.params)
    },
    onExport() {
      var loading = this.$loading({
        lock: true,
        text: "正在导出...",
        spinner: "el-icon-loading",
        customClass: "my_loading",
        background: "rgba(0, 0, 0, 0.3)",
      });
      this.api.exportV2(this.params).then(() => {
        loading.close();
      });
    }
  },
};
</script>
<style>
.el-tabs__header {
  border-bottom: none !important;
}
.el-tabs__nav {
  border: 1px solid #E4E7ED !important;
}
</style>